import { Link, useNavigate } from "react-router-dom";

import TemplateGallery from "../../commonComponents/CC_templateGallery";
import SnippetsGrid from '../../components/snippetsGrid';
import DatafeedGrid from "../../components/datafeedGrid";

import {linkStyle} from "../../components/helpersStyles";
import { IconButton, Tooltip } from '@mui/material';
import { Icon as Iconify } from '@iconify/react';
import { CcCreateNewSnippet, CcSubSectionTitle, CcTitle } from '../../commonComponents/styledTexts';
import { useEffect } from "react";

import introJs from 'intro.js';
import 'intro.js/introjs.css'
import '../../ccIntroJs/ccIntroJsStyles.css'
import { CcIntroJsStyledText } from '../../ccIntroJs/ccIntroJsStyledText';
import { showIntroJsTourForCurrentPage } from '../../ccIntroJs/ccIntroJsDisplayLogic';

export default function ProductHomeWeatherForecasts() {
    useEffect(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;

        showIntroJsTourForCurrentPage(introJs)
    }, [])

    const navigate = useNavigate();

    const handleCreateDataConnection = () => {
        navigate("/contentsources");
    }

    return <div>
            <CcTitle>
                Weather Forecasts
            </CcTitle>
            <div className="w-fit" data-intro={CcIntroJsStyledText({title: 'Start here', mainText: 'This launches a wizard that: <ul class="list-disc ml-4">  <li>Creates a <span class="font-semibold">template</span></li><li>Creates an <span class="font-semibold">element</span></li></ul><div class="mt-2">A <span class="font-semibold">template</span> is a reusable design. You can create multiple elements from the same template</div><div class="mt-2">An <span class="font-semibold">element</span> is the html tag to copy into your email</div>'})}>
                <Link to={`/workflow/18`} style={linkStyle}> 
                    <CcCreateNewSnippet className="mt-4" >Create new Weather Forecasts Image</CcCreateNewSnippet>
                </Link>
            </div>
            <div className=" mt-3 border border-gray-300 rounded-md p-1 flex flex-col gap-2">
                <div className="w-fit" data-intro={CcIntroJsStyledText({title: 'Template section', mainText: '<div>Here you can view/edit your templates</div><div>You can also create a new element from an existing template</div>'})}>
                     <CcSubSectionTitle>Start with existing Template</CcSubSectionTitle>
                 </div>
                <div>
                <TemplateGallery productTypeId={18} />
                </div>
            </div>

            <div className="w-fit" data-intro={CcIntroJsStyledText({title: 'Elements section', mainText: '<div>List of all the Elements you created</div><div>You can edit an element even if you have already put it in a live email</div>'})}>
                <CcSubSectionTitle className="mt-6">Latest Weather Forecasts Elements</CcSubSectionTitle>
            </div>
            <SnippetsGrid productTypeId={18}
                 //editCall={(id, typeId) => editSnippet(id, typeId)}
             />

    </div>
}